import { v4 as uuidv4 } from 'uuid'

import { getResUrl } from './env'

export function stringStartWith(data: string, matchStr: string): boolean {
  return new RegExp(`^${matchStr}`).test(data)
}

export function stringEndWith(data: string, matchStr: string): boolean {
  return new RegExp(`${matchStr}$`).test(data)
}

export function isStrBlank(strValue: null | undefined | string): boolean {
  return strValue === null || strValue === undefined || strValue === ''
}

export function isStrContain(str: string, subStr: string): boolean {
  return str != null && str.includes(subStr)
}

export function convertToString(value: any): string {
  if (value instanceof Error) {
    return value.message
  } else if (typeof value === 'string') {
    return value
  } else if (value !== null && typeof value === 'object') {
    return JSON.stringify(value)
  } else {
    return String(value || '')
  }
}

export function buildQueryStr(params: any, filterParams?: Array<string>): string {
  let paramString = ''
  if (params) {
    for (const key in params) {
      if (filterParams && filterParams.includes(key)) {
        continue
      }
      const value = params[key]
      if (typeof value === 'function' || value === null || value === undefined) {
        continue
      } else {
        if (paramString.length > 0) {
          paramString = `${paramString}&`
        }
        paramString = `${paramString + key}=${encodeURIComponent(value)}`
      }
    }
  }
  return paramString
}

export function parseQueryString(queryStr: string): any {
  const params = {}
  //   Regex for replacing addition symbol with a space
  const a = /\+/g
  const r = /([^&=]+)=?([^&]*)/g
  const d = function (s: string) {
    return decodeURIComponent(s.replace(a, ' '))
  }
  let e = r.exec(queryStr)
  while (e) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    params[d(e[1])] = d(e[2])
    e = r.exec(queryStr)
  }
  return params
}

export function parseUrlParams(): any {
  const q = window.location.search.substring(1)
  return parseQueryString(q)
}

export function shortString(val: string, prefix: number, post: number) {
  if (!val) {
    return val
  }
  const length = val.length
  if (length <= prefix + post) {
    return val
  }
  let result = ''
  if (prefix && val.length > prefix) {
    result = result + val.substring(0, prefix)
  }
  result = `${result}...`
  if (post && val.length - prefix > post) {
    result = result + val.substring(val.length - post)
  }
  return result
}

export function randomString(base: string) {
  return `${base + new Date().getTime()}_${Math.ceil(Math.random() * 10000)}`
}

export function formatString(msg: string, ...args: Array<any>) {
  if (!msg) {
    return msg
  }
  if (args && args.length > 0) {
    let newMsg = msg
    const length = args.length
    for (let i = 0; i < length; i++) {
      newMsg = newMsg.replace(`{${i}}`, args[i].toString())
    }
    return newMsg
  }
  return msg
}

export function formatThousandNum(num: number | string): string {
  return (+num || 0).toString().replace(/^-?\d+/g, (m) => m.replace(/(?=\B(\d{3})+$)/g, ','))
}

export function camelCase(lower: boolean, ...args: Array<string>) {
  const length = args.length
  let result = ''
  for (let i = 0; i < length; i++) {
    if (i === 0) {
      if (lower) {
        result = result + args[i]!.substring(0, 1).toLowerCase() + args[i]!.substring(1)
      } else {
        result = result + args[i]!.substring(0, 1).toUpperCase() + args[i]!.substring(1)
      }
    } else {
      result = result + args[i]!.substring(0, 1).toUpperCase() + args[i]!.substring(1)
    }
  }
  return result
}

export function capitalize(str: string) {
  return camelCase(false, str)
}

export function unCapitalize(str: string) {
  return camelCase(true, str)
}

export function parseInteger(str: any, defaultValue?: number): number | undefined {
  if (str === undefined) {
    return defaultValue
  } else if (Array.isArray(str)) {
    if (str.length > 0) {
      return parseInteger(str[0])
    }
    return defaultValue
  } else {
    const num = Number.parseInt(str)
    if (Number.isNaN(num)) {
      return defaultValue
    }
    return num
  }
}

export function genUid(): string {
  // return String(new Date().getTime()) + String(Math.floor(Math.random() * 1000))
  const myUUID = uuidv4()
  return myUUID.replaceAll('-', '')
}

export function getErrMsg(error: any, defaultMsg: string): string {
  if (typeof error === 'object') {
    if (error && error.message) {
      return (error.message as string) || defaultMsg
    }
  }
  return defaultMsg
}

export function formatErrMsg(error: any): string {
  if (typeof error === 'object') {
    if (error && error.message) {
      return error.message as string
    } else {
      return JSON.stringify(error)
    }
  } else {
    return String(error)
  }
}

export function formatInteger(value: number | string) {
  let num = (value || 0).toString()
  let result = ''
  while (num.length > 3) {
    result = `,${num.slice(-3)}${result}`
    num = num.slice(0, num.length - 3)
  }
  if (num) {
    result = num + result
  }
  return Number(result)
}

export function resourceUrl(url: string | undefined, defaultUrl?: string): string | undefined {
  if (!url) {
    if (defaultUrl && !defaultUrl.startsWith('/')) {
      return resourceUrl(defaultUrl)
    } else {
      return defaultUrl
    }
  }
  const index = url.indexOf('://')
  if (index > 0) {
    // 指定协议
    const schema = url.substring(0, index).toLocaleLowerCase()
    if (schema === 'icon') {
      // 自定义的icon协议, 去除协议前缀
      return url.substring(index + 3)
    }
    return url
  }
  if (url.startsWith('/')) {
    return url
  }
  const pIndex = url.indexOf('/')
  const prefix = url.substring(0, pIndex)
  const resUrl = getResUrl(prefix)
  const list: string[] = []
  if (resUrl) {
    list.push(resUrl)
  }
  list.push(url)
  return list.join('/')
}

export function resourceUrls(urls: string | string[] | undefined, defaultUrl?: string): string[] {
  if (!urls) {
    return []
  }
  if (Array.isArray(urls)) {
    return urls.map((url) => resourceUrl(url, defaultUrl)) as string[]
  } else {
    return urls.split(',').map((url) => resourceUrl(url, defaultUrl)) as string[]
  }
}

export function parseNumberArg(value?: any) {
  if (value === undefined) {
    return undefined
  } else if (Array.isArray(value)) {
    return Number(value[0])
  } else {
    return Number(value)
  }
}

export function parseStringArg(value?: any, type?: 'upper' | 'lower') {
  if (value === undefined) {
    return undefined
  }
  const result = Array.isArray(value) ? value[0] : value
  if (type === 'upper') {
    return result?.toUpperCase()
  } else if (type === 'lower') {
    return result?.toLowerCase()
  }
  return result
}
